import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Basket } from '../types/basket.type';
import { UpdateBasketRequestDTO } from '../types/dtos/update-basket.dto';
import { ADMIN_BASKETS_API_PATHS } from '../constants/baskets-api-paths.constants';

type UpdateBasketParams = {
  basketId: string;
  basketData: UpdateBasketRequestDTO;
};

type UseUpdateBasketResult = {
  updateBasket: (params: UpdateBasketParams) => Promise<Basket | null>;
  isSubmitting: boolean;
};

export function useUpdateBasket(): UseUpdateBasketResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateBasket = async ({ basketId, basketData }: UpdateBasketParams): Promise<Basket | null> => {
    setIsSubmitting(true);

    try {
      const updatedBasket = await HttpClient.patch<Basket, UpdateBasketRequestDTO>(
        ADMIN_BASKETS_API_PATHS.UPDATE_BASKET(basketId),
        basketData
      );

      enqueueSnackbar('Le panier a été mis à jour', { variant: 'success' });
      return updatedBasket;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la mise à jour du panier'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { updateBasket, isSubmitting };
}
